import React from 'react';
import Iconify from 'src/components/iconify';
import { Box, Button, Card, Divider, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import "./style.css"
import RenderField from '../../risk-register/render-field';
const ReportsViewTable = ({ data }) => {
    console.log("🚀 ~ RiskChangeViewTable ~ data:", data)
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    };
    return (
        <Card>
            <Box p={3}>
                <Typography className="incident-view-main-heading"></Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
                <Box sx={{ position: 'relative' }}>
                    <Typography variant="h4" className="pull-left mt-2 ribbon ribbon-bookmark ribbon-success">
                        Risk Change View{' '}
                    </Typography>
                </Box>
                <Box>
                    <Button
                        className='dark-button'
                        sx={{ marginRight: '20px', marginTop: '22px' }}
                        onClick={goBack}
                        size="md"
                        variant="contained"
                        startIcon={<Iconify icon="ep:back" width={16} />}
                    >
                        Go Back
                    </Button>
                </Box>
            </Box>
            <Box
                p={4}
                mt={4}
                rowGap={3}
                columnGap={20}
                display="grid"
                gridTemplateColumns={{
                    xs: 'repeat(1, 1fr)',
                    sm: 'repeat(3, 1fr)',
                }}
            >
                <RenderField label="Requsted ID" value={data?.request_id} />
                <RenderField label="Original Risk ID" value={data?.identification_and_assessment?.risk_id} />
                <RenderField label="Request Changes " value={data?.requested_changes} />
            </Box>
            <Divider />
            <Box
                p={4}
                rowGap={3}
                columnGap={20}
                display="grid"
                gridTemplateColumns={{
                    xs: 'repeat(1, 1fr)',
                    sm: 'repeat(3, 1fr)',
                }}
            >
                <RenderField label="Reason for Change" value={data?.reason_for_change} />
                <RenderField label="Requested By" value={data?.requested_by} />
                <RenderField label="Approval Status" value={data?.approval_status} />
            </Box>
            <Divider />

            <Box
                p={4}
                rowGap={3}
                columnGap={20}
                display="grid"
                gridTemplateColumns={{
                    xs: 'repeat(1, 1fr)',
                    sm: 'repeat(3, 1fr)',
                }}
            >
            </Box>
        </Card>
    );
};
export default ReportsViewTable;